export * from './src/page-nav.module';
